import { JwtHelperService } from '@auth0/angular-jwt';
import { AccessToken } from '@shared/api/common/access-token';


export abstract class TokenUtil {
  static readonly helper = new JwtHelperService();

  static tokenIsValid(token: AccessToken) {
    try {
      const decodeToken = this.helper.decodeToken(token.access_token);
      return (decodeToken.exp * 1000) >= Date.now();
    } catch {
      return false;
    }
  }
}
